import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from './kotlin-kotlin-stdlib.mjs';
import {
  IShiftAccessor1pahto1t0k4qo as IShiftAccessor,
  IShiftMutator12aals7g8731k as IShiftMutator,
  IShiftInvalidator3ba6keaeoutnl as IShiftInvalidator,
  IShiftCompositeAccessor1yspg8epnn0zc as IShiftCompositeAccessor,
} from './Shared7Punches-domain-shift-domain.mjs';
import {
  Clientssjxb7gh2u6y as Client,
  ApiVersion_JULY_2026_getInstance26s1g5r9ct27x as ApiVersion_JULY_2026_getInstance,
} from './Shared7Punches-infrastructure-network.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
import {
  ILocationAccessor2jiwvdkvuuw23 as ILocationAccessor,
  IDepartmentAccessor2hj1il6ko3wqn as IDepartmentAccessor,
  IRoleAccessor21b6uyhytfsm9 as IRoleAccessor,
} from './Shared7Punches-data-core.mjs';
import { IUserAccessor2r676j1t9f9ew as IUserAccessor } from './Shared7Punches-domain-user-domain.mjs';
//region block: imports
//endregion
//region block: pre-declaration
initMetadataForClass(ShiftRepository, 'ShiftRepository', VOID, VOID, [IShiftAccessor, IShiftMutator, IShiftInvalidator], [1, 2, 0]);
initMetadataForClass(Composer, 'Composer', Composer);
initMetadataForClass(ShiftCompositeService, 'ShiftCompositeService', VOID, VOID, [IShiftCompositeAccessor]);
initMetadataForInterface(IShiftRemoteSource, 'IShiftRemoteSource', VOID, VOID, VOID, [1, 2]);
initMetadataForCompanion(Companion);
initMetadataForClass(ShiftRemoteSource, 'ShiftRemoteSource', VOID, VOID, [IShiftRemoteSource], [1, 2, 0]);
//endregion
function get_shiftModule() {
  _init_properties_ShiftModule_kt__6dhoo4();
  return shiftModule;
}
var shiftModule;
function shiftModule$lambda($this$module) {
  _init_properties_ShiftModule_kt__6dhoo4();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = shiftModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IShiftRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = shiftModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ShiftRepository), null, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  var tmp = new KoinDefinition($this$module, factory_0);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$9 = [getKClass(IShiftAccessor), getKClass(IShiftMutator), getKClass(IShiftInvalidator)];
  binds(tmp, tmp$ret$9);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = shiftModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(Composer), null, tmp2_0, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = shiftModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(ShiftCompositeService), null, definition_0, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  var tmp_0 = new KoinDefinition($this$module, factory_2);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$19 = [getKClass(IShiftCompositeAccessor)];
  binds(tmp_0, tmp$ret$19);
  return Unit_instance;
}
function shiftModule$lambda$lambda($this$factory, it) {
  _init_properties_ShiftModule_kt__6dhoo4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new ShiftRemoteSource(tmp, tmp$ret$1);
}
function shiftModule$lambda$lambda_0($this$single, it) {
  _init_properties_ShiftModule_kt__6dhoo4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(IShiftRemoteSource), null, null);
  return new ShiftRepository(tmp$ret$0);
}
function shiftModule$lambda$lambda_1($this$factory, it) {
  _init_properties_ShiftModule_kt__6dhoo4();
  return new Composer();
}
function shiftModule$lambda$lambda_2($this$single, it) {
  _init_properties_ShiftModule_kt__6dhoo4();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IShiftAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(ILocationAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(IDepartmentAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_2 = $this$single.q1d(getKClass(IRoleAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$4 = $this$single.q1d(getKClass(IUserAccessor), null, null);
  return new ShiftCompositeService(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$4);
}
var properties_initialized_ShiftModule_kt_egzlj6;
function _init_properties_ShiftModule_kt__6dhoo4() {
  if (!properties_initialized_ShiftModule_kt_egzlj6) {
    properties_initialized_ShiftModule_kt_egzlj6 = true;
    shiftModule = module_0(VOID, shiftModule$lambda);
  }
}
function ShiftRepository(remoteSource) {
  this.r8l_1 = remoteSource;
}
function Composer() {
}
function ShiftCompositeService(shiftAccessor, locationAccessor, departmentAccessor, roleAccessor, userAccessor) {
  this.s8l_1 = shiftAccessor;
  this.t8l_1 = locationAccessor;
  this.u8l_1 = departmentAccessor;
  this.v8l_1 = roleAccessor;
  this.w8l_1 = userAccessor;
  this.x8l_1 = new Composer();
}
function IShiftRemoteSource() {
}
function Companion() {
  Companion_instance = this;
  this.y8l_1 = ApiVersion_JULY_2026_getInstance();
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function ShiftRemoteSource(api, sessionDataProvider) {
  Companion_getInstance_0();
  this.z8l_1 = api;
  this.a8m_1 = sessionDataProvider;
}
//region block: exports
export {
  get_shiftModule as get_shiftModule31ix6ju6k3lmq,
};
//endregion

